<template>
  <div class="job-card">
    <div class="job-card-header">
      <a
        target="__blank"
        class="job-card-header__station"
        :href="`/job/detail?id=${jobInfo.positionId}`"
        >{{ jobInfo.positionName }}</a
      >
      <span class="job-card-header__slot">
        <slot name="header"></slot>
      </span>
    </div>
    <div class="job-card-main">
      <div class="job-card-main__info">
        <span class="station-price">{{ jobInfo.salaryRangeName }}</span>
        <span class="job-card-main__info-item">{{
          jobInfo.address || jobInfo.cityCodeName
        }}</span>
        <span class="job-card-main__info-item">{{
          jobInfo.workExperienceName || `${jobInfo.workExperience}年以上`
        }}</span>
        <span class="job-card-main__info-item">{{
          jobInfo.qualificationsName
        }}</span>
        <span class="job-card-main__info-item"
          >招聘{{ jobInfo.numbers }}人</span
        >
        <span class="job-card-main__info-item"
          >{{ jobInfo.deptName }}</span
        >
      </div>
      <slot name="resume"></slot>
      <div class="job-card-main__meta">
        <a
          class="company-name"
          target="__blank"
          :href="`/job/detail?id=${jobInfo.positionId}`"
          >{{ jobInfo.companyName }}</a
        >
        <div>
          <span class="time" v-if=jobInfo.effectiveStart >发布于{{ jobInfo.effectiveStart }}</span>
          <span class="status" v-show="showStatus" @click="handleShowFooter">
            {{ jobInfo.stateDesc }}
            <span class="fonticon">&#xe6aa;</span>
          </span>
          <slot name="status"></slot>
        </div>
      </div>
    </div>
    <div class="job-card-footer" v-show="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jobInfo: {
      type: Object,
      default: () => {}
    },
    showStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFooter: false
    };
  },
  methods: {
    handleShowFooter() {
      this.showFooter = !this.showFooter;
      this.$emit("showFooter", this.showFooter);
    }
  }
};
</script>

<style lang="scss">
.job-card {
  background-color: #ffffff;
  padding: 20px 0;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__station {
      font-size: 18px;
      color: #666666;
    }
  }
  &-main {
    &__info {
      margin: 15px 0;
      font-size: 16px;
      color: #666666;
      .station-price {
        font-size: 18px;
        color: #ff5555;
        margin-right: 15px;
      }
      &-item {
        padding: 0 10px;
        position: relative;
        &:not(:last-child)::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 10px;
          background-color: #666666;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    &__meta {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #666666;
      .time {
        margin-right: 20px;
      }
      .status {
        cursor: pointer;
        position: relative;
        z-index: 1;
      }
      .company-name {
        color: #666666;
      }
    }
  }

  &-footer {
    background-color: #f5f5f5;
    padding: 10px;
    color: #ff5555;
    font-size: 12px;
    margin-top: 20px;
    position: relative;
    &::before {
      content: "";
      display: inline-block;
      border: 20px solid transparent;
      border-bottom-color: #f5f5f5;
      position: absolute;
      right: 20px;
      top: -30px;
    }
  }
}
</style>
